import styled from 'styled-components';

import Container from '../../Core/Container';
import checkmark from '../../../images/green_checkmark.svg';

export const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.velvet};
  padding: 36px 0 40px;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 70px 0 80px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 100px 0 120px;
  }
`;

export const Grid = styled(Container)`
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Headline = styled.h2`
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 32px;
  text-align: center;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 60px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.xlg}) {
    margin-bottom: 78px;
  }
`;

export const UL = styled.ul`
  width: 100%;
  height: calc(100%);
  max-width: 1140px;
  margin: 0;

  li {
    list-style: none;
    margin-bottom: 25px;

    a {
      color: inherit;
    }
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    columns: 2;
    column-gap: 40px;
    column-fill: balance;

    li {
      display: inline-block;
      width: 100%;
      margin-bottom: 28px;
    }
  }
`;

export const Feature = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;

  &::before {
    content: '';
    background-image: url(${checkmark});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 22.75px;
    min-width: 22.75px;
    margin-right: 15.25px;
  }

  p {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    font-size: 16px;
    line-height: 24px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    &::before {
      margin-right: 22.25px;
    }

    p {
      font-size: 20px;
      line-height: 25px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 55px;

  a {
    margin: 10px;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-top: 60px;
  }
`;
